// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Saudi Arabia */
const SA = /^(?:579[0-8]\d{5}|5(?:[013-689]\d|7[0-8])\d{6})$/;

export default SA;
